// extracted by mini-css-extract-plugin
export default {"spinner-container":"RelativeEffort--spinner-container--3CghA","spinnerContainer":"RelativeEffort--spinner-container--3CghA","container":"RelativeEffort--container--6dZ9v"};